export default "__VITE_ASSET__c9871d91__"